import React from 'react';

import styled, { css } from 'styled-components';

import { useGetGroupInsights } from 'hooks/queries/dashboard';
import use1000FollowerTable from 'hooks/table/use1000FollowerTable';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import style from 'styles/styled-components/style';
import { more_1000_follower_header_arr } from 'utils/table';

function More1000FollowerRanking() {
	const [groupId] = useGetSearchParams(['groupId']);
	const { data: groupInsights, isLoading: groupInsightsLoading } =
		useGetGroupInsights(groupId);

	const followerRanking1000 = groupInsights?.highFollowerCommenters;

	const match_cell_mapper = use1000FollowerTable();

	if (groupInsightsLoading) {
		return (
			<Grid flex="center" direction="column">
				<TableHeaderWrapper>
					{more_1000_follower_header_arr.map((item, idx) => (
						<React.Fragment key={idx}>
							<Grid _width={`${item.width}px`} flex="start" align="center">
								<Text white_space="pre" typo="span">
									{item.header}
								</Text>
								{item.name !== 'contents' && item.name !== 'link' && (
									<Text typo="span"></Text>
								)}
							</Grid>
						</React.Fragment>
					))}
				</TableHeaderWrapper>
				<Grid _margin="0 0 8px 0">
					{Array(5)
						.fill(0)
						.map((_, row_idx) => (
							<React.Fragment key={row_idx}>
								<TableRow selected={false}>
									<Grid flex="center">
										<CoreLoading color_type="gray" />
									</Grid>
								</TableRow>
							</React.Fragment>
						))}
				</Grid>
			</Grid>
		);
	}

	return (
		<Grid flex="center" direction="column">
			<TableHeaderWrapper>
				{more_1000_follower_header_arr.map((item, idx) => (
					<React.Fragment key={idx}>
						<Grid _width={`${item.width}px`} flex="start" align="center">
							<Text white_space="pre" typo="span">
								{item.header}
							</Text>
							{item.name !== 'contents' && item.name !== 'link' && (
								<Text typo="span"></Text>
							)}
						</Grid>
					</React.Fragment>
				))}
			</TableHeaderWrapper>
			<Grid _margin="0 0 8px 0">
				{followerRanking1000?.map((data, row_idx) => (
					<React.Fragment key={row_idx}>
						<TableRow selected={false}>
							{more_1000_follower_header_arr.map((item, idx) => (
								<React.Fragment key={idx}>
									{match_cell_mapper[item.name](data, idx, row_idx)}
								</React.Fragment>
							))}
						</TableRow>
					</React.Fragment>
				))}
			</Grid>
		</Grid>
	);
}
const { Grid, Text } = style;

const TableHeaderWrapper = styled(Grid)`
	height: 66px;
	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border-bottom: 1px solid ${({ theme }) => theme.colors.gray.gray15};
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
	padding: 0 32px 0 103px;

	/* 투두 */
	${({ theme }) => theme.common.flexStart}

	div {
		cursor: pointer;
	}
`;

const TableRow = styled(Grid)<{ selected: boolean }>`
	min-width: calc(100% - 32px);
	height: 65px;

	border-radius: 8px;
	margin-top: 8px;
	padding: 0 16px;
	/* cursor: pointer; */

	${({ theme }) => theme.common.flexStart}

	background-color: ${({ theme }) => theme.colors.gray.gray_white};
	border: 1px solid ${({ theme }) => theme.colors.gray.gray_white};

	${({ theme, selected }) =>
		selected &&
		css`
			border: 1px solid ${theme.colors.uplus.primary10_lighten};
		`}

	&:hover {
		cursor: pointer;
		border-color: ${({ theme }) => theme.colors.uplus.bg10_lighten};
		background-color: ${({ theme }) => theme.colors.uplus.bg10_lighten};
		${({ theme, selected }) =>
			selected &&
			css`
				border-color: ${theme.colors.uplus.primary50_key};
			`}
	}
`;
export default More1000FollowerRanking;
